import ajaxLoader from './ajax-loader.gif';
export {ajaxLoader};

import profileIcon from './profile-round.svg';
export {profileIcon};

import mpIcon from './mp-round.svg';
export {mpIcon};


// WEBPACK FOOTER //
// ./src/modules/resources/index.js